import React from "react";
import BrandMark from "../components/BrandMark";

export default function About() {
  return (
    <div data-testid="about-page" className="pt-32 pb-24">
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        <div className="text-[11px] tracking-[0.4em] uppercase text-[#279153] mb-4">Scéal · The Story</div>
        <h1 className="font-serif-display text-5xl text-white mb-10">An atelier under the redwoods.</h1>
        <div className="space-y-6 text-base text-[#95A89C] leading-relaxed">
          <p>
            Grá is the Irish word for love — and that is the only honest word for what this studio is built on. A love of song, of land, and of the slow craft of making things by hand.
          </p>
          <p>
            Each piece released here, whether a ballad, a photograph or a knot-drawing, is recorded and rendered directly by the artist. There are no labels, no print shops, no warehouses — just the work, watermarked, and a way for it to find its way to your home.
          </p>
          <p>
            The redwoods are real. The clover is real. And the Celtic knot you see overlaid on every preview is the mark that keeps the work safe in the wild.
          </p>
        </div>
        <div className="mt-16 border-t border-[#1A2B20] pt-10 flex items-center gap-4">
          <BrandMark variant="knot" className="h-12 w-12 block" style={{ opacity: 0.6 }} />
          <div>
            <div className="font-serif-display text-xl text-white">Go raibh maith agat</div>
            <div className="text-xs text-[#5C7064] tracking-wider">Thank you for being here.</div>
          </div>
        </div>
      </div>
    </div>
  );
}
